'use strict';

require('../components/checkbox');
require('./competitorsSuggest');
require('./modalSettings');
require('./save');
require('../modals/deleteReview');

$('[data-toggle="tooltip"]').tooltip();
